<template>
  <vDialog :show.sync="visible" class="withdrawal_freeze_dialog">
    <template v-slot:header>
      <span class="close"><i class="el-icon el-icon-close" @click="handleClose"></i></span>
      <div class="font-semibold text-xl text-blackG2">{{ $t('security.withdrawalFreeze.header') }}</div>
    </template>
    <template v-slot:body>
      <div class="text-sm mt-8" v-if="fromFunctionCode === 'updateUserLogin'">
        {{ $t('security.withdrawalFreeze.userLoginDesc', { days: limitDayNumber, hours: lastHours }) }}
      </div>
      <div class="text-sm mt-8" v-if="fromFunctionCode === 'updatePassword'">
        {{ $t('security.withdrawalFreeze.passDesc', { days: limitDayNumber, hours: lastHours }) }}
      </div>
      <div class="text-sm mt-8" v-if="fromFunctionCode === 'changeAuthenticator'">
        {{ $t('security.withdrawalFreeze.limitSecurityAuthenticator', { days: limitDayNumber, hours: lastHours }) }}
      </div>
    </template>
    <template v-slot:btn>
      <div class="text-center">
        <PrimaryButton
          padding="px-10"
          height="h-12"
          width="min-w-42"
          :onClick="handleClose"
          class="dialog-btn"
          bgColor="!bg-blueG1"
          >{{ $t('security.understand') }}
        </PrimaryButton>
      </div>
    </template>
  </vDialog>
</template>

<script>
import vDialog from '@/components/vDialog.vue';
import PrimaryButton from '@/components/buttons/primaryButton/PrimaryButton.vue';
import SecondaryButton from '@/components/buttons/secondaryButton/SecondaryButton.vue';
import { apiGetSecurity } from '@/resource';

export default {
  name: 'WithdrawalFreezeDialog',
  components: { vDialog, PrimaryButton, SecondaryButton },
  props: {
    // emit: confirmSubmit
    freezeDialogVisible: { type: Boolean, default: false },
    isFreeze: { type: Boolean, default: false },
    selectedWithdrawChannel: { type: Number, default: null }
  },
  data() {
    return {
      visible: false,
      fromFunctionCode: undefined,
      limitDayNumber: undefined,
      lastHours: undefined,
      limitWithdrawTypes: undefined
    };
  },
  watch: {
    freezeDialogVisible(freezeDialogVisible) {
      if (freezeDialogVisible) {
        this.confirmShowFreezeDialog();
      }
    }
  },
  methods: {
    // use method instead of watch
    // prevent unchanged visible state -> not triggering emit
    handleVisible(bool) {
      this.visible = bool;
      this.$emit('update:freezeDialogVisible', bool);
    },
    handleClose() {
      this.handleVisible(false);
    },
    confirmSubmit() {
      this.handleVisible(false);
      this.$emit('confirmSubmit');
    },
    confirmShowFreezeDialog() {
      this.getFreezePeriod()
        .then(resp => {
          if (
            resp &&
            this.fromFunctionCode &&
            this.limitDayNumber &&
            this.lastHours &&
            this.limitWithdrawTypes &&
            this.limitWithdrawTypes.includes(this.selectedWithdrawChannel)
          ) {
            this.handleVisible(true);
            this.$emit('update:isFreeze', true);
          } else {
            this.handleVisible(false);
            this.$emit('update:isFreeze', false);
            this.confirmSubmit();
          }
        })
        .catch(() => {
          this.handleVisible(false);
        });
    },
    async getFreezePeriod() {
      try {
        let result = false;
        await apiGetSecurity().then(resp => {
          if (resp.data.code === 0) {
            let data = resp.data.data || [];
            // 按时间排序
            const withdrawLimitArrays = data
              .filter(el => el.functionCode == 'withdraw')
              .sort((a, b) => b.limitTimeUTC - a.limitTimeUTC);
            // 找到按时间排序后并且包含该选中渠道的第一个限制
            const currLimitObj = withdrawLimitArrays.find(item => {
              let curr = item.limitWithdrawTypes ? item.limitWithdrawTypes.split(',').map(item => Number(item)) : [];
              return curr.includes(this.selectedWithdrawChannel);
            });
            // 如果找到限制
            if (currLimitObj && Object.keys(currLimitObj).length > 0) {
              this.fromFunctionCode = currLimitObj.fromFunctionCode;
              this.limitDayNumber = 'T + ' + currLimitObj.limitDayNumber;
              this.lastHours = currLimitObj.lastHours;
              this.limitWithdrawTypes = currLimitObj.limitWithdrawTypes?.length
                ? currLimitObj.limitWithdrawTypes.split(',').map(Number)
                : undefined;
              result = true;
            } else {
              result = false;
            }
          } else {
            console.error('Get limit day number fails');
          }
        });
        return result;
      } catch (error) {
        console.error('error', error);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.withdrawal_freeze_dialog {
  .close {
    position: absolute;
    right: 20px;
    cursor: pointer;
  }
  /deep/ {
    .el-dialog__header {
      padding: 5px 20px;
    }
  }
}
</style>
